module.exports = __webpack_public_path__ + "static/img/about-05.8a68d5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-05.png
// module id = bf5z
// module chunks = 0